import { Search as SearchIcon } from '@mui/icons-material'
import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { KSmallIconButton } from 'components/core/KButton'
import { useState } from 'react'
import { SearchArea } from './SearchArea'
import { SearchInput } from './SearchInput'

export const SearchHandler = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  const handleOpenSearch = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    setIsSearchOpen(true)
  }

  const handleCloseSearch = () => {
    setIsSearchOpen(false)
  }

  if (isMobile) {
    return (
      <>
        <KSmallIconButton onClick={handleOpenSearch}>
          <SearchIcon />
        </KSmallIconButton>

        <SearchArea open={isSearchOpen} onClose={handleCloseSearch} />
      </>
    )
  }

  return (
    <>
      <Stack flexGrow={1} alignItems="center">
        <SearchInput
          onClick={handleOpenSearch}
          sx={{ maxWidth: 400, width: '100%' }}
        />
      </Stack>
      <SearchArea open={isSearchOpen} onClose={handleCloseSearch} />
    </>
  )
}
